export default "__VITE_ASSET__DN0atrbd__"